export const deviceTypes = {
  UNKNOWN: 'Noch nicht erfasst',
  FIREWALL: 'Firewall',
  ROUTER: 'Router',
  SWITCH: 'Switch',
  ACCESS_POINT: 'Access Point',
  NETWORK_CONTROLLER: 'Netzwerkcontroller / Cloud Key',
  UPS: 'USV',
  NAS: 'NAS',
  PBX: 'Telefonanlage',
  NOTEBOOK: 'Notebook',
  WORKSTATION: 'Workstation',
  SERVER: 'Server',
  MOBILE: 'Mobilgerät',
  PRINTER: 'Drucker',
  OTHER: 'Sonstiges',
};
export const deviceExecutions = {
  UNKNOWN: 'Noch nicht erfasst',
  PHYSICAL: 'Physisch',
  VIRTUAL: 'Virtuell / VM',
};
export const deviceHostings = {
  UNKNOWN: 'Noch nicht erfasst',
  ON_PREMISES: 'OnPrem',
  CLOUD: 'Cloud',
  HOSTED: 'Externes Rechenzentrum',
};
export const deviceFormFactors = {
  UNKNOWN: 'Noch nicht erfasst',
  MINI_PC: 'Mini-PC / NUC',
  DESKTOP: 'Desktop',
  TOWER: 'Tower',
  RACK: 'Rack',
  APPLIANCE: 'Appliance',
};
